export enum FavoriteTypes {
	dataframe = 'dataframe',
	chart = 'chart',
	report = 'report',
	dashboard = 'dashboard',
	table = 'table',
	presentation = 'presentation',
}
